import { render, staticRenderFns } from "./TigerSchoolBanner.vue?vue&type=template&id=72aac6fa&scoped=true"
import script from "./TigerSchoolBanner.vue?vue&type=script&lang=ts"
export * from "./TigerSchoolBanner.vue?vue&type=script&lang=ts"
import style0 from "./TigerSchoolBanner.vue?vue&type=style&index=0&id=72aac6fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72aac6fa",
  null
  
)

export default component.exports